<main>
  <div class="page-wrapper">
    <!-- Overlay -->
    <div class="loader-overlay" *ngIf="showLoaderOverlay">
      <div class="spinner-wrapper">
        <app-loader-overlay></app-loader-overlay>
      </div>
    </div>

    <!-- Content -->
    <div class="loaded-content" [class.blurred]="!showLoaderOverlay">
      <!-- Breadcrumbs -->
      <xng-breadcrumb>
        <div class="breadcrumbs" *xngBreadcrumbItem="let breadcrumb">
          <div class="container-xl">
            <ul class="breadcrumbs-list">
              <li><a [routerLink]="['/home']">Home</a></li>
              <li>
                <a>{{ breadcrumb }}</a>
              </li>
            </ul>
          </div>
        </div>
      </xng-breadcrumb>

      <!-- Title Bar -->
      <lib-title-bar title="Menu Config"></lib-title-bar>

      <section class="container-xl">
        <!-- Content -->
        <div class="content">
          <div class="code-editor">
            <div class="top-controlsLine">
              <div class="controls">
                <!-- Title -->
                <div class="to-left">
                  <div class="editor-bullets">
                    <div class="bullet"></div>
                    <h3>Live Code <em>(String Format)</em></h3>
                  </div>
                </div>
                <div class="to-right">
                  <div class="controls-actions">
                    <a mat-stroke-button color="primary" class="btn-cancel" (click)="rollBackChanges()"
                      ><i class="fa-solid fa-xmark"></i> Cancel</a
                    >
                    <button mat-flat-button (click)="saveData()" color="primary" class="btn-save">
                      <i class="fa-solid fa-floppy-disk"></i> Save
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="editor-content">
              <div class="editor-lineNumber">
                <ul>
                  <li *ngFor="let item of linesCount; let index = index">{{ index }}</li>
                </ul>
              </div>
              <div class="code">
                <textarea
                  [(ngModel)]="menuDataString"
                  (input)="detectChanges($event)"
                  class="txt-editor"
                  id="txtEditor"
                  >{{ menuDataString | json }}</textarea
                >
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</main>
